import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { Guide, saveGuide as saveGuideFromMonolith } from '~/monolith-api/guides';

export type SaveGuideOptions = Partial<Omit<Guide, 'flags' | 'image'>> & {
   objectid?: number | null;
   image?: number | null;
   introduction?: string;
   flags?: string[];
   major_release_approval_processid?: number | null;
   minor_release_approval_processid?: number | null;
};

const saveGuideSchema = z.object({
   guideid: z.number(),
   revisionid: z.number(),
   fields: z.object({}).passthrough(),
});

export default createBFFHandlers({
   post: async (req, res) => {
      const { guideid, revisionid, fields } = saveGuideSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await saveGuideFromMonolith({
         guideid,
         revisionid,
         fields,
         common: {
            apiClient: monolithClient,
         },
      });
      res.status(200).json(result);
   },
});

export const saveGuide = async (
   guideid: number,
   revisionid: number,
   fields: SaveGuideOptions
): Promise<typeof saveGuideFromMonolith> => {
   return bff()
      .post('/guides/saveGuide', {
         guideid,
         revisionid,
         fields,
      })
      .then(response => response.data);
};
